module.exports = __webpack_public_path__ + "img/28.efa39085.jpg";